/** User ID for user that is not logged in */
export const NOT_LOGGED_IN_USER_ID = -1;
export const ENVIRONMENT_CODES = ['dev', 'uat', 'pat', 'stg', 'live'];
//# sourceMappingURL=constants.js.map